import { DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'jspdf-autotable';
import { ToastrService } from 'ngx-toastr';
import { PessoaService } from '../../shared/services/pessoa.service';
import { FinanceiroService } from './../service/financeiro.service';


@Component({
  selector: 'app-contracheque',
  templateUrl: './contracheque.component.html',
  styleUrls: ['./contracheque.component.css']
})
export class ContrachequeComponent implements OnInit {

  // @BlockUI() blockUi: NgBlockUI;

  // cols: any[];

  // cdCentrus: number;
  // // cdCentrus = 10014;

  // componentes: any[] = [1];

  // mesesAno: SelectItem[] = [];

  // contrachequeList: Array<ContrachequeListDTO> = new Array<ContrachequeListDTO>();
  // bonusLista: Array<ContrachequeListDTO> = new Array<ContrachequeListDTO>();
  // informacaoContrachequeDTO: InformacaoContrachequeDTO = new InformacaoContrachequeDTO()
  // mesAno: string;

  // mesAnoModel = new MesAnoModel();

  // contraChequeFuncCentrusModel: ContraChequeFuncCentrusModel = new ContraChequeFuncCentrusModel();
  // contraChequeAposentadosModel: ContraChequeAposentadosModel = new ContraChequeAposentadosModel();

  // dadosCadastrais: Array<InformacaoContrachequeDTO> = new Array<InformacaoContrachequeDTO>();

  // pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  // page: number;
  // param: string;
  // outros = false;
  // bonus = false;

  constructor(
    private financeiroService: FinanceiroService,
    private activatedRoute: ActivatedRoute,
    private _decimalPipe: DecimalPipe,
    private pessoaService: PessoaService,
    private toastrService: ToastrService,
    private router: Router
  ) {
  }



  ngOnInit() {
    // this._identificaoTipoContracheque();




    // this.cols = [
    //   { field: 1, header: 'Verba' },
    //   { field: 2, header: 'Descrição' },
    //   { field: 3, header: 'Parcela' },
    //   { field: 4, header: 'Saldo/Base de Cáculo' },
    //   { field: 5, header: 'Competência' },
    //   { field: 6, header: 'Valor' }
    // ];


    // 474584
    // 629618
  }

  // getDadosSesseionStorage(): void {
  //   this.blockUi.start();
  //   try {
  //     const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
  //     this._gerenciarCodigoIndentificao(recuperandoObjeto)
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     this.blockUi.stop();
  //   }
  // }

  // private _gerenciarCodigoIndentificao(recuperandoObjeto): void {

  //   if (recuperandoObjeto) {
  //     const novoObjeto = Number(JSON.parse(recuperandoObjeto));
  //     this.cdCentrus = novoObjeto
  //     this.param = '/administrativo/operacoesConsultaParticipante';
  //   } else {
  //     this.cdCentrus = 629618;
  //     this.param = '/cardMenus/cardMenuFinanceiro';
  //   }
  // }


  // private _identificaoTipoContracheque(): void {

  //   const tipoRecebido = this.activatedRoute.snapshot.params.identicacao;
  //   this.page = ContrachequeEnum.getValue(tipoRecebido);

  //   this.getDadosSesseionStorage();

  //   this.getdDataReferencia()
  //   this.getPessoasDadosSimplificado();
  // }


  // async getPessoasDadosSimplificado() {
  //   this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoasDadosSimplificado(this.cdCentrus);
  // }


  // async getdDataReferencia() {
  //   this.mesesAno = [];
  //   const mesesRetorno = await this.financeiroService.getDataReferencia(this.cdCentrus);
  //   mesesRetorno.map(item => {
  //     this.mesesAno.push({ label: item, value: item })
  //   })
  //   this.mesAno = mesesRetorno[0];
  //   this.getEspelhoFolhaPagtoWeb(this.mesAno)
  // }


  // getContrachequeFuncCentrus(mesAno) {
  //   this.getEspelhoFolhaPagtoWeb(mesAno);
  // }


  // getEspelhoFolhaPagtoWeb(mesAno: string) {
  //   this.informacaoContrachequeDTO = new InformacaoContrachequeDTO();
  //   this.dadosCadastrais = new Array<InformacaoContrachequeDTO>();
  //   this.contrachequeList = new Array<ContrachequeListDTO>();


  //   if (mesAno === null) {
  //     return;
  //   }

  //   this.mesAnoModel = new MesAnoModel(Number(mesAno.split('/')[0]), Number(mesAno.split('/')[1]));

  //   if (this.page === 3) {
  //     this.getEspelhoFolhaPagtoWebAposentados(this.mesAnoModel)
  //     return;
  //   }


  //   this.getEspelhoFolhaPagtoWebFunc(this.mesAnoModel);
  // }


  // async getEspelhoFolhaPagtoWebFunc(mesAnoModel: MesAnoModel) {
  //   try {
  //     const contracheque = await this.financeiroService.getEspelhoFolhaPagtoWebFunc(this.cdCentrus, mesAnoModel.mes, mesAnoModel.ano);
  //     this.informacaoContrachequeDTO = new InformacaoContrachequeDTO(
  //       contracheque.noPessoa,
  //       null,
  //       contracheque.sgLocal,
  //       null,
  //       Number(contracheque.vlBruto),
  //       Number(contracheque.vlDescontos),
  //       Number(contracheque.vlLiquido),
  //       contracheque.nrBanco,
  //       contracheque.nrAgencia,
  //       contracheque.nrContaCorrente,
  //       contracheque.qtDepIr,
  //       contracheque.qtDepSalFam,
  //       Number(contracheque.vlMargem30),
  //       Number(contracheque.vlMargem70),
  //       (contracheque.cdFuncao + ' - ' + contracheque.sgCarreira),
  //       contracheque.vlSalarioBase,
  //       contracheque.vlFgts,
  //       contracheque.dsMensagemInd,
  //       'Valores passiveis de alteração e a data do credito'.toUpperCase(),

  //     )

  //     contracheque.contrachequeDetalhesValoresFuncDTO.map(contracheque => {
  //       if ((Number(contracheque.cdVerba) === 681) ||
  //         (Number(contracheque.cdVerba) === 691) ||
  //         (Number(contracheque.cdVerba) === 741)) {
  //         this.outros = true;
  //       }
  //       if ((Number(contracheque.cdVerba) === 545) ||
  //         (Number(contracheque.cdVerba) === 546) ||
  //         (Number(contracheque.cdVerba) === 547) ||
  //         (Number(contracheque.cdVerba) === 548) ||
  //         (Number(contracheque.cdVerba) === 1603)) {
  //         this.bonus = true;
  //       }
  //     })



  //     this.dadosCadastrais.push(this.informacaoContrachequeDTO);

  //     this.contrachequeList.push(new ContrachequeListDTO(null, 'Proventos'.toUpperCase(), null, null, null, null));


  //     contracheque.contrachequeDetalhesValoresFuncDTO.map(index => {
  //       if (Number(index.cdVerba) < 1000
  //         && Number(index.cdVerba) !== 681
  //         && Number(index.cdVerba) !== 691
  //         && Number(index.cdVerba) !== 741
  //         && Number(index.cdVerba) !== 545
  //         && Number(index.cdVerba) !== 546
  //         && Number(index.cdVerba) !== 547
  //         && Number(index.cdVerba) !== 548
  //       ) {

  //         this.contrachequeList.push(
  //           new ContrachequeListDTO(
  //             (index.cdVerba + '.' + index.cdVariacao),
  //             index.dsVerbasCent.trim(),
  //             index.dsComplemento,
  //             this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
  //             this.mesAno,
  //             this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
  //           ));
  //       }
  //     })

  //     if (this.outros) {
  //       this.contrachequeList.push(new ContrachequeListDTO(null, 'Outros'.toUpperCase(), null, null, null, null))
  //     }

  //     contracheque.contrachequeDetalhesValoresFuncDTO.map(index => {
  //       if (Number(index.cdVerba) === 681
  //         && Number(index.cdVerba) === 691
  //         && Number(index.cdVerba) === 741
  //       ) {

  //         this.contrachequeList.push(
  //           new ContrachequeListDTO(
  //             (index.cdVerba + '.' + index.cdVariacao),
  //             index.dsVerbasCent.trim(),
  //             index.dsComplemento,
  //             this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
  //             this.mesAno,
  //             this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
  //           ));
  //       }
  //     })

  //     this.contrachequeList.push(new ContrachequeListDTO(null, 'Descontos'.toUpperCase(), null, null, null, null))


  //     contracheque.contrachequeDetalhesValoresFuncDTO.map(index => {
  //       if (Number(index.cdVerba) > 999
  //         && Number(index.cdVerba) !== 1603) {

  //         this.contrachequeList.push(
  //           new ContrachequeListDTO(
  //             (index.cdVerba + '.' + index.cdVariacao),
  //             index.dsVerbasCent.trim(),
  //             index.dsComplemento,
  //             this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
  //             this.mesAno,
  //             this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
  //           ));
  //       }
  //     })

  //     contracheque.contrachequeDetalhesValoresFuncDTO.map(index => {
  //       if (Number(index.cdVerba) === 545
  //         && Number(index.cdVerba) === 546
  //         && Number(index.cdVerba) === 547
  //         && Number(index.cdVerba) === 548
  //         && Number(index.cdVerba) === 1603
  //       ) {
  //         this.bonusLista.push(
  //           new ContrachequeListDTO(
  //             (index.cdVerba + '.' + index.cdVariacao),
  //             index.dsVerbasCent.trim(),
  //             index.dsComplemento,
  //             this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
  //             this.mesAno,
  //             this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
  //           ));
  //       }
  //     })
  //     if (this.contrachequeList.length === 0) {
  //       this.voltarForcada()
  //     }

  //   } catch (error) {
  //      this.router.navigate([this.param])
  //     this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  //   }
  // }

  // async getEspelhoFolhaPagtoWebAposentados(mesAnoModel: MesAnoModel) {

  //   try {


  //     const contracheque = await this.financeiroService.getEspelhoFolhaPagtoWebAposentados(this.cdCentrus, mesAnoModel.mes, mesAnoModel.ano);
  //     this.informacaoContrachequeDTO = new InformacaoContrachequeDTO(
  //       contracheque.noPessoa,
  //       null,
  //       contracheque.sgRegional,
  //       null,
  //       Number(contracheque.vlBruto),
  //       Number(contracheque.vlDescontos),
  //       Number(contracheque.vlLiquido),
  //       contracheque.nrBanco,
  //       contracheque.nrAgencia,
  //       contracheque.nrContaCorrente,
  //       contracheque.qtDepIr,
  //       contracheque.qtDepSalFam,
  //       Number(contracheque.vlMargem30),
  //       Number(contracheque.vlMargem70),
  //       (contracheque.cdFuncao + ' - ' + contracheque.sgCarreira),
  //       null,
  //       null,
  //       contracheque.dsMensagemInd,
  //       contracheque.dsMensagemGeral,
  //       contracheque.nrBenefInss,
  //       contracheque.nrNossoNumero,
  //       (contracheque.irIsencaoIr === '1') ? 'Sim' : 'Não',
  //       contracheque.cdFuncao,
  //       (contracheque.cdVp + ' / ' + contracheque.qtAnuenio)
  //     )

  //     this.contrachequeList.push(
  //       new ContrachequeListDTO(null, 'Proventos'.toUpperCase(), null, null, null, null));

  //     this.dadosCadastrais.push(this.informacaoContrachequeDTO)

  //     contracheque.contrachequeDetalhesValoresAposentadosDTO.map(index => {
  //       if (index.irConsignacao === '3') {
  //         this.contrachequeList.push(
  //           new ContrachequeListDTO(
  //             (index.cdVerba + '.' + index.cdVariacao),
  //             index.dsVerba.trim(),
  //             index.dsComplemento,
  //             this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
  //             index.dtCompetencia,
  //             this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
  //           ));
  //       }
  //     })


  //     this.contrachequeList.push(new ContrachequeListDTO(null, 'Descontos'.toUpperCase(), null, null, null, null))

  //     contracheque.contrachequeDetalhesValoresAposentadosDTO.map(index => {
  //       if (index.irConsignacao === '1') {
  //         this.contrachequeList.push(
  //           new ContrachequeListDTO(
  //             (index.cdVerba + '.' + index.cdVariacao),
  //             index.dsVerba.trim(),
  //             index.dsComplemento,
  //             this._decimalPipe.transform(Number(index.vlBsCalculo), '1.2-2'),
  //             index.dtCompetencia,
  //             this._decimalPipe.transform(Number(index.vlVerba), '1.2-2')
  //           ));
  //       }
  //     })

  //     if (this.contrachequeList.length === 0) {
  //       this.voltarForcada()
  //     }

  //   } catch (error) {
  //      this.router.navigate([this.param])
  //     this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  //   }

  // }



  // imprimirPagina() {
  //   this.contrachquePdf.funcionarios(this.mesAno, this.pessoaDadosSimplicadosModel, this.informacaoContrachequeDTO,
  //     this.contrachequeList, this.page, this.bonus, this.bonusLista);
  // }

  // voltarForcada(): void {
  //    this.router.navigate([this.param]);
  //   this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO, '', { timeOut: 8000 })
  // }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/contracheque/contracheque.component.ts